import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { PropertiesService } from 'src/app/services/properties.service';
import { ClientPropertyFilesUploadDialogData } from './client-property-files-upload-dialog.viewmodel';
import { FilePreviewModel } from '@anaidenko/ngx-awesome-uploader';
import { FileUploaderComponent } from 'src/app/shared/components/file-uploader/file-uploader.component';
import { ClientPropertyFilesUploadDialogAdapter } from './client-property-files-upload-dialog.adapter';
import { GlobalErrorsHandler } from 'src/app/core/errors/global-errors.handler';

@Component({
  selector: 'app-client-property-files-upload-dialog',
  templateUrl: './client-property-files-upload-dialog.component.html',
  styleUrls: ['./client-property-files-upload-dialog.component.css']
})
export class ClientPropertyFilesUploadDialogComponent implements OnInit {

  @ViewChild(FileUploaderComponent, { static: true })
  fileUploader!: FileUploaderComponent;

  adapter       = new ClientPropertyFilesUploadDialogAdapter(this.http, this.propertiesService);
  filesAdded    = 0;
  filesUploaded = 0;
  error         = '';

  get uploading() {
    return this.filesAdded !== this.filesUploaded;
  }

  constructor(
    private dialogRef: MatDialogRef<ClientPropertyFilesUploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: ClientPropertyFilesUploadDialogData,
    private http: HttpClient,
    private propertiesService: PropertiesService,
    private errorsHandler: GlobalErrorsHandler
  ) {
    this.adapter.propertyID = data.propertyID;
    this.adapter.userID = data.userID;
  }

  ngOnInit(): void {
  }

  save() {
    this.dialogRef.close({ uploaded: this.filesUploaded > 0 });
  }

  close() {
    this.fileUploader.removeFiles();
    this.dialogRef.close({ uploaded: false });
  }

  onFileAdded(file: FilePreviewModel) {
    this.filesAdded++;
  }

  onUploaded(file: FilePreviewModel) {
    this.filesUploaded++;
  }

  onUploadFailed(error: HttpErrorResponse) {
    this.error = this.errorsHandler.getDisplayMessage(error) || 'unknown';
    alert(this.error);
  }
}
